"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _header = _interopRequireDefault(require("../../header/header"));

var _navButton = _interopRequireDefault(require("../../../common/nav-button/nav-button"));

var _upgradeButton = _interopRequireDefault(require("../../../common/upgrade-button/upgrade-button"));

var _myAccount = _interopRequireDefault(require("../../../common/my-account/my-account"));

var _actionMenuTypes = _interopRequireDefault(require("../../../common/app-action-menu/action-menu-types"));

var _supportPopup = _interopRequireDefault(require("../../../common/support-popup/support-popup"));

const WordpressHeader = props => {
  const {
    onFaqClick,
    onSupportClick,
    onSendSupportMessage,
    hasBilling,
    onBillingClick,
    children,
    leftChildren,
    hasPricing,
    onPricingClick,
    hasUpgrade,
    onUpgradeClick,
    className,
    fullName,
    storeName,
    storeDomain,
    onMyAccountOpen
  } = props,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["onFaqClick", "onSupportClick", "onSendSupportMessage", "hasBilling", "onBillingClick", "children", "leftChildren", "hasPricing", "onPricingClick", "hasUpgrade", "onUpgradeClick", "className", "fullName", "storeName", "storeDomain", "onMyAccountOpen"]);
  const [showSupportPopup, setShowSupportPopup] = (0, _react.useState)(false);

  const openSupportPopup = () => {
    setShowSupportPopup(true);
    onSupportClick();
  };

  const closeSupportPopup = () => {
    setShowSupportPopup(false);
  };

  const onMyAccountSelect = value => {
    switch (value) {
      case _actionMenuTypes.default.BILLING:
        onBillingClick();
        break;

      case _actionMenuTypes.default.SUPPORT:
        openSupportPopup();
        break;

      case _actionMenuTypes.default.FAQ:
        onFaqClick();
        break;
    }
  };

  const getMenuTypes = () => {
    const menuTypes = [_actionMenuTypes.default.SUPPORT, _actionMenuTypes.default.FAQ];

    if (hasBilling) {
      menuTypes.unshift(_actionMenuTypes.default.BILLING);
    }

    return menuTypes;
  };

  return /*#__PURE__*/_react.default.createElement(_header.default, (0, _extends2.default)({
    className: (0, _classnames.default)('wordpress-header', className)
  }, otherProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "header__section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header__separator"
  }), leftChildren, hasPricing && /*#__PURE__*/_react.default.createElement(_navButton.default, {
    onClick: onPricingClick
  }, "Pricing")), /*#__PURE__*/_react.default.createElement("div", {
    className: "header__section"
  }, children, hasUpgrade && /*#__PURE__*/_react.default.createElement(_upgradeButton.default, {
    onClick: onUpgradeClick
  }, "Upgrade"), /*#__PURE__*/_react.default.createElement("div", {
    className: "header__separator"
  }), /*#__PURE__*/_react.default.createElement(_myAccount.default, {
    fullName: fullName,
    storeName: storeName,
    storeUrl: storeDomain,
    onSelect: onMyAccountSelect,
    onOpen: onMyAccountOpen,
    menuTypes: getMenuTypes()
  })), showSupportPopup && /*#__PURE__*/_react.default.createElement(_supportPopup.default, {
    onCancel: closeSupportPopup,
    onClose: closeSupportPopup,
    onSendMessage: onSendSupportMessage
  }));
};

WordpressHeader.propTypes = {
  children: _propTypes.default.node,
  leftChildren: _propTypes.default.node,
  onSupportClick: _propTypes.default.func,
  onFaqClick: _propTypes.default.func.isRequired,
  onSendSupportMessage: _propTypes.default.func.isRequired,
  hasPricing: _propTypes.default.bool,
  onPricingClick: _propTypes.default.func,
  hasUpgrade: _propTypes.default.bool,
  onUpgradeClick: _propTypes.default.func,
  fullName: _propTypes.default.string.isRequired,
  storeName: _propTypes.default.string.isRequired,
  storeDomain: _propTypes.default.string.isRequired,
  onMyAccountOpen: _propTypes.default.func,
  hasBilling: _propTypes.default.bool,
  onBillingClick: _propTypes.default.func,
  className: _propTypes.default.string
};
WordpressHeader.defaultProps = {
  children: null,
  leftChildren: null,
  onSupportClick: () => {},
  hasPricing: false,
  onPricingClick: () => {},
  hasUpgrade: false,
  onUpgradeClick: () => {},
  onMyAccountOpen: () => {},
  hasBilling: false,
  onBillingClick: () => {},
  className: ''
};
var _default = WordpressHeader;
exports.default = _default;